let config = {
  "keyAnimationMaxSpeed": 5,
  "keyAnimationAccelerate": 0.25,
};

export default config;



// WEBPACK FOOTER //
// ./src/config/client.js